import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Salon, Table } from "../model/salon.model";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { takeUntil } from "rxjs/internal/operators/takeUntil";
import { ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";

@Component({
  selector: "ngx-salon-form",
  templateUrl: "./salon-form.component.html",
  styleUrls: ["./salon-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalonFormComponent extends BaseFormComponent<Salon> implements OnInit {
  start: number = 1;
  end: number = 5;
  IsActive: boolean = false;
  tableName: string = this.translate("ClientApp.FrontOffice.Salon.Table");
  haserror: boolean = false;
  erroremessage: string;
  Tables: form_control[];
  deactivateSave: boolean = false;
  onPermissionDelete: boolean = false;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, protected sts: ShowToastrService) {
    super(selectorService, cd);
    this.FillData();
  }

  async ngOnInit() {
    this.apiName = "Salon";
    this.label = this.translate("ClientApp.FrontOffice.Salon.Salons");
    super.ngOnInit();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.Tables = undefined;
  }
  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.Tables = this.getDetailControlModels("Tables");
  }
  setdefault() {
    if (!this.model.Tables) this.model.Tables = [];
    if (this.model.BranchId == undefined) this.model.BranchId = this.accountService.authService.currentBranchId;
    if (this.model && this.model?.Tables?.length > 0) {
      this.end = this.model.Tables.length;
      this.model.Tables = this.model.Tables.sort(function (a, b) {
        return a.Code - b.Code;
      });
      this.setValue("end", this.end);
      this.setValue("tableName", this.tableName);
    }
  }

  ngCreateTables(): void {
    this.start = this.formGroup.controls["start"].value;
    this.end = this.formGroup.controls["end"].value;
    this.tableName = this.formGroup.controls["tableName"].value;
    this.IsActive = this.formGroup.controls["IsActive"].value;
    if (this.start > 999 || this.end > 999) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Salon.EnterAppropriateValue");
      return;
    } else {
      let newTableName: string;
      let found = false;
      for (var i = this.start; i <= this.end; i++) {
        newTableName = this.tableName + " " + i;
        var table = new Table();
        table.Title = newTableName;
        table.Code = i;
        table.IsActive = true;
        table.SalonId = this.model.Id > 0 ? this.model.Id : 0;
        this.model.Tables.forEach((x) => {
          if (x.State != RowState.Delete && x.State != RowState.Detached && (x.Code === i || x.Title == newTableName)) {
            x.Title = newTableName;
            x.Code = i;
            x.IsActive = true;
            x.State = RowState.Modify;
            found = true;
            return;
          }
          //this.tableName = newTableName;
        });
        if (!found) {
          table.State = RowState.New;
          this.model.Tables.push(table);
        }
        found = false;
      }
      var temp = Object.assign([], this.model.Tables);
      this.model.Tables = [];
      this.model.Tables = temp;
      this.cd.markForCheck();
    }
  }
  addControl() {
    this.setValue("start", this.start);
    this.setValue("end", this.end);
    this.setValue("tableName", this.tableName);
    this.setValue("IsActive", this.model.IsActive != null ? this.model.IsActive : true);
  }
  isValid(): boolean {
    this.erroremessage = undefined;
    this.haserror = false;
    if (this.model && this.model.Tables) {
      let tables = this.model.Tables.filter((t) => t.State != RowState.Delete && t.State != RowState.Detached);
      if (tables.length > 0) {
        let tableTitleArray = tables.map(function (table) {
          return table.Title;
        });
        let isDuplicateTitle = tableTitleArray.some(function (item, idx) {
          return tableTitleArray.indexOf(item) != idx;
        });
        if (isDuplicateTitle) {
          this.haserror = true;
          this.erroremessage = this.translate("ClientApp.FrontOffice.Salon.TitleTableCannotRepeated");
        }
        let tableCodeArray = tables.map(function (table) {
          return table.Code;
        });
        if (tableCodeArray.some((x) => !x)) {
          this.haserror = true;
          this.erroremessage = this.translate("ClientApp.FrontOffice.Salon.TableCodeMandatory");
        }
        let isDuplicateCode = tableCodeArray.some(function (item, idx) {
          return tableCodeArray.indexOf(item) != idx;
        });
        if (isDuplicateCode) {
          this.haserror = true;
          this.erroremessage = this.translate("ClientApp.FrontOffice.Salon.TableCodeCannotDuplicated");
        }
      } else {
        this.haserror = true;
        this.erroremessage = this.translate("ClientApp.FrontOffice.Salon.SelectingLeastOneTableRequired");
      }
    }
    return !this.haserror;
  }
  //beforupdate() {
  //this.model.Tables = this.model.Tables.filter(f => f.State != RowState.Delete && f.State != RowState.Detached);
  // }
  onDelete($event) {
    if (this.onPermissionDelete) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Salon.HasBranchCommunication"),
        this.translate("ClientApp.FrontOffice.Salon.Attention")
      );
    }
  }
  async FillData() {
    if (
      this.accountService.authService.currentInformation().BranchingLightEnabled ||
      this.accountService.authService.currentInformation().BranchingAdvancedEnabled
    ) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch" + "/Salon")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((hbc: CheckBrachAccessModel) => {
          if (hbc.TransferKindCode != 3) {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Salon.HasBranchCommunication"),
                this.translate("ClientApp.FrontOffice.Salon.Attention")
              );
              this.deactivateSave = true;
              return;
            } else {
              if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                this.sts.showDialog(
                  this.translate("ClientApp.FrontOffice.Salon.HasCallCenterCommunication"),
                  this.translate("ClientApp.FrontOffice.Salon.Attention")
                );
                this.deactivateSave = true;
                return;
              }
            }
          }
        });
      (error) => this.getFailedHelper(error);
    }
  }
}
